<template>
  <div class="client-wrapper d-flex justify-content-between align-items-center">
    <div v-if="noLink" class="d-flex">
      <!-- div class="logo-client">
        <img :src="imgUrl" alt="" />
      </div -->
      <div class="nom-client">
        <p>{{ clientName }}</p>
      </div>
    </div>
    <b-link v-else :to="'/dashboard/list-user/' + clientId" class="d-flex">
      <div class="logo-client">
        <img :src="imgUrl" alt="" />
      </div>
      <div class="nom-client">
        <p>{{ clientName }}</p>
      </div>
    </b-link>
    <div class="action-client" v-if="role">
      <ul class="d-flex">
        <li v-if="!isModal">
          <b-link :to="'/dashboard/edit-client/' + clientId"
            ><font-awesome-icon :icon="['far', 'edit']"
          /></b-link>
        </li>
        <li v-if="isModal">
          <b-link @click="editEvent"
            ><font-awesome-icon :icon="['far', 'edit']"
          /></b-link>
        </li>
        <li>
          <span
            @click="deleteEvent"
            :style="{ cursor: 'pointer' }"
            ><font-awesome-icon :icon="['far', 'trash-alt']"
          /></span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import store from '@/store'
export default {
  props: {
    imgName: {
      type: String,
      required: false
    },
    clientName: {
      type: String,
      required: true
    },
    clientId: {
      type: String,
      required: true
    },
    isModal: {
      type: Boolean,
      default: false
    },
    noLink: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      imgUrl: require('@/assets/images/' + this.imgName),
      role: ['ROLE_EDITEUR', 'ROLE_ADMIN'].includes(store.getters.userRole)
    }
  },
  methods: {
    deleteEvent () {
      this.$emit('delete', this.clientId)
    },
    editEvent () {
      this.$emit('edit', this.clientId)
    }
  }
}
</script>
<style lang="scss">
.client-wrapper {
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #2b3085;
  margin-bottom: 15px;
  padding-right: 10px;
  height: 30px;
  line-height: 30px;
  .logo-client {
    height: 56px;
    width: 56px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .nom-client {
    padding: 0 5px;
    color: #2b3085;
    align-self: center;
    font-size: 15px;
    font-family: 'Noto Sans', sans-serif;

    p {
      margin-bottom: 0;
    }
  }
  .action-client {
    ul {
      padding-left: 0;
      list-style: none;
      margin-bottom: 0;
      li {
        padding-left: 5px;
        padding-right: 5px;
        svg {
          color: #2b3085;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/blocTypeClient.vue